/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import { object } from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

const styles = (theme) => ({
    padding: {
        padding: '0 10px',
        '& img': {
            width: '100%',
        },
    },
    label: {
        margin: '10px 0  20px 0',
        textAlign: 'center',
        fontSize: 16,
        color: theme.palette.sympathyPage?.linkColor,
        fontWeight: 600,
    },
    link: {
        textDecoration: 'none',
    },
});

const Flowers = ({ classes, data }) => {
    const { link, label, img } = data;
    return (
        <Grid className={classes.padding} key={link} item xs={6}>
            <Link className={classes.link} to={link}>
                <img src={`${img}?height=354&width=324`} alt={label} />
                <h3 className={classes.label}>{ReactHtmlParser(label)} &gt;</h3>
            </Link>
        </Grid>
    );
};

Flowers.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
};

export default withStyles(styles)(Flowers);
